import { getName } from "@rentiohq/shared-frontend/dist/redux/contact/contact.utils";
import { getPropertyTypeString } from "@rentiohq/shared-frontend/dist/reduxV2/property/property.utils";
import { EPaymentRepetitionType } from "@rentiohq/shared-frontend/dist/types/payment.types";
import { IPaymentRequest } from "@rentiohq/shared-frontend/dist/types/paymentRequest.types";
import {
  EPropertyMemberTypes,
  IProperty,
} from "@rentiohq/shared-frontend/dist/types/property.types";
import { formatAddress } from "@rentiohq/shared-frontend/dist/utils/address.utils";
import { formatDate } from "@rentiohq/shared-frontend/dist/utils/date.utils";
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import * as paymentRequestUtils from "@rentiohq/shared-frontend/dist/utils/paymentRequest.utils";

export const valuesForPaymentRequest = (
  paymentRequest: IPaymentRequest,
  property?: IProperty,
) => {
  const paymentType = paymentRequestUtils.getTitle(paymentRequest);

  const isRecurring =
    paymentRequest.repetitionType !== EPaymentRepetitionType.Once;

  const optionalPeriod = isRecurring
    ? getLocalizedText(
        "payment.payment_order.first_payment.period.value.basic",
        {
          startDate: formatDate(paymentRequest.startedAt, "d MMMM yyyy"),
          endDate: formatDate(paymentRequest.endedAt, "d MMMM yyyy"),
        },
      ).toLowerCase()
    : undefined;

  let address = "";
  if (property) {
    address = formatAddress(property);
  }

  let propertyType = "";
  if (property?.typeId) {
    propertyType = (
      getPropertyTypeString({ typeId: property.typeId }) || ""
    ).toLowerCase();
  }

  let financialAdmin = "Rentio";
  if (property) {
    const members = property.members.filter(member =>
      member.roles.includes(EPropertyMemberTypes.FinancialManager),
    );

    if (members.length > 0) {
      financialAdmin = getName(members[0].account);
    }
  }

  return {
    financial_admin: financialAdmin,
    optional_period: optionalPeriod ? ` ${optionalPeriod}` : "",
    propertyType,
    address,
    paymentType,
    sepaBankDaysOffset: `${paymentRequestUtils.sepaDeductionDaysFromNow(
      paymentRequest,
    )}`,
  };
};
